import { type IContent } from "@kunduz/data-access-cms-api";
import { getCmsIcon } from "../static/iconMappings";

export const prepareCmsMenuItems = (
  iconColor: string,
  cmsData?: IContent.HeaderItemsResponse["components"],
  onClick?: (label: string) => void,
  kunduzApiToken?: string,
): {
  title: string;
  url?: string;
  items?: {
    title: string;
    desc?: string;
    icon?: JSX.Element;
    url: string;
  }[];
  variant: any;
}[] => {
  if (!cmsData) return [];

  return cmsData
    ?.filter((x) => x.type == "headermenucomponent")
    ?.filter((x) => {
      if (kunduzApiToken) return !x.data.hide_for_authenticated_user;
      else return !x.data.hide_for_unauthenticated_user;
    })
    .map((item) => {
      return {
        title: item.data.title as string,
        url: item.data.url,
        onClick: () => onClick?.(item.data.title as string),
        items: item.data.childs?.map((child) => {
          const Icon = child.icon ? getCmsIcon(child.icon) : undefined;

          return {
            title: child.title,
            url: child.url || "#",
            desc: child.description,
            icon: child.icon ? <Icon color={iconColor} /> : undefined,
            onClick: () => onClick?.(child.title),
          };
        }),
        variant: "regular",
      };
    });
};
